// Day-grid constants (ported from the prototype: DS=9, DE=18, PEAK=[9,12]).
// All time-of-day values in this package are MINUTES FROM MIDNIGHT, matching
// the `tasks.fromHour` column in the DB schema.

export const DAY_START_MIN = 9 * 60; // 540 — grid starts 09:00
export const DAY_END_MIN = 18 * 60; // 1080 — grid ends 18:00
export const PEAK_START_MIN = 9 * 60; // deep-work band start
export const PEAK_END_MIN = 12 * 60; // deep-work band end
export const SLOT_MIN = 30; // scheduling granularity
export const DEFAULT_EST_MIN = 30; // default task estimate

/** Priority → accent color, mirrors the prototype PRIC map (extended to 4). */
export const PRIORITY_COLOR: Record<number, string> = {
  1: "#FF6B81",
  2: "#FFB454",
  3: "#43E0A0",
  4: "#5A6480",
};
